import angular from "angular";

angular
	.module('app')
	.component('moderatorAddDetailModal', {
		template: require('./moderator-add-detail-modal.html'),
        controller: ['$http', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });
    
function controller($http) {
 
	let $ctrl = this;

	$ctrl.categories = null;
	$ctrl.repType = null;
	$ctrl.repValue = null;
	$ctrl.category = null;
	$ctrl.unit = 'шт';
	$ctrl.loading = false;

	$ctrl.$onInit = function () {
	    $ctrl.name = $ctrl.resolve.name;
	    $ctrl.newName = $ctrl.resolve.name;
	    $ctrl.categories = $ctrl.resolve.categories;
    };

	$ctrl.add = () => {
		$ctrl.loading = true;
		let url = '/moderator/details/store';
		let params = {
			other_name: $ctrl.name,
			category_id: $ctrl.category.id,
			name: $ctrl.newName,
			replacement_type: $ctrl.repType,
			replacement_value: $ctrl.repValue,
			unit: $ctrl.unit,
		}
		$http.post(url, params).then(() => {
			$ctrl.loading = false;
			window.Swal.fire({
				icon: 'success',
				title: 'Успешно добавлено',
			}).then(function () {
				window.location = '/moderator/others';
			})
		});
    }
}